angular.module('payments-comp', [
		require('./component-utils/src/index'),

		require('./formatters/index'),
		require('./validators/index')
	])
	.directive('ctPayments', ctPaymentsDirective)
	.factory('CtPayments', CtPaymentsFactory);

function ctPaymentsDirective() {
	return {
		restrict: 'A',
		require: 'ctPayments',
		controller: Ctrl,
		link: postLink
	};

	function postLink(scope, element, attrs, CtPaymentsCtrl) {
		element.addClass('ct-payments');
		CtPaymentsCtrl.element = element;

		scope.cvcType = 'password';
		scope.toggleCvc = function () {
			if (scope.cvcType == 'password') {
				scope.cvcType = 'text';
			} else {
				scope.cvcType = 'password';
			}
		};
	}

	function Ctrl() {
		var card, month, year;

		this.setCard = function (c) {
			card = c;
		};
		this.getCard = function () {
			return card;
		};
		this.setMonth = function (m) {
			month = m;
		};
		this.getMonth = function () {
			return month;
		};
		this.setYear = function (y) {
			year = y;
		};
		this.getYear = function () {
			return year;
		};
	}
}

function CtPaymentsFactory($filter) {
	return {
		months: months,
		years: years
	};

	function months() {
		return ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	}

	function years(count) {
		var filter = $filter('date'),
			date = new Date,
			label = filter(date, 'yyyy'),
			year = filter(date, 'yy'),
			years = [];

		count = count ? count : 10;

		for (var i = 0; i < count; ++i) {
			years.push({
				label: label++,
				value: year++
			});
		}

		return years;
	}
}
module.exports = 'payments-comp';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/ct-payments/index.js
 ** module id = 97
 ** module chunks = 1
 **/